import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enJson from './translations/en.json'
import esESJson from './translations/esES.json'
import ptBRJson from './translations/ptBR.json'

export const getBrowserLanguage = () => {
    try {
        if (!navigator) {
            return 'es-ES';
        }
        const browserLang = navigator?.language || 'pt-BR';

        switch (browserLang) {
            case 'en-US':
                return 'en-US';
            case 'es-ES':
                return 'es-ES';
            default:
                return browserLang;
        }

    } catch (error) {
        console.error('Error getting browser language:', error);
        return 'pt-BR';
    }
}

export const getStoredLanguage = (businessLanguage) => {
    try {
        const storedLanguage = sessionStorage.getItem("@prit-web/language");

        if (!storedLanguage && !businessLanguage) {
            return getBrowserLanguage();
        }
        
        switch (storedLanguage || businessLanguage) {
            case 'english':
              return 'en-US';
            case 'spanish':
              return 'es-ES';
            case 'portuguese':
              return 'pt-BR';
            default:
              return getBrowserLanguage();
        }
    } catch (error) {
        console.warn('Error getting stored language:', error);
        return 'pt-BR';
    }
}

export const setLanguageFromBusiness = (businessLanguage) => {
    try {
        
        if (!businessLanguage) {
            return 'pt-BR';
        }
        
        switch (businessLanguage.toLowerCase()) {
            case 'english':
              return 'en-US';
            case 'spanish':
              return 'es-ES';
            case 'portuguese':
              return 'pt-BR';
            default:
              return 'pt-BR';
        }
    } catch (error) {
        console.error('Error setting language from business:', error);
        return 'pt-BR';
    }
}

if (typeof window !== 'undefined' && !sessionStorage.getItem("@prit-web/language")) {
    const locale = (navigator.language || '').toLowerCase();
    let lang = 'portuguese';
    if (locale.startsWith('en')) lang = 'english';
    else if (locale.startsWith('es')) lang = 'spanish';
    sessionStorage.setItem("@prit-web/language", lang);
}

i18n.use(initReactI18next).init({
    fallbackLng: 'pt-BR',
    lng: getStoredLanguage() || getBrowserLanguage() || 'pt-BR',
    interpolation: {
        escapeValue: false,
    },
    resources: {
        "en-US": enJson,
        "pt-BR": ptBRJson,
        "es-ES": esESJson,
    },
});

export const updateLanguage = () => {
    try {
        const newLanguage = getStoredLanguage();
        
        if (newLanguage && i18n.isInitialized && i18n.language !== newLanguage) {
            i18n.changeLanguage(newLanguage);
        }
    } catch (error) {
        console.error('Error updating language:', error);
    }
};

const handleStorageChange = (e) => {
    if (e.key === "@prit-web/language") {
        updateLanguage();
    }
};

if (typeof window !== 'undefined') {
    window.addEventListener('storage', handleStorageChange);
    
    const originalSetItem = sessionStorage.setItem;
    sessionStorage.setItem = function(key, value) {
        originalSetItem.apply(this, arguments);
        if (key === "@prit-web/language") {
            updateLanguage();
        }
    };
}

export default i18n;